import React from 'react'
import HeroImg from '../../../assets/images/company-formation/offshore-company-formation/hero-img.png'
import BannerImg from '../../../assets/images/company-formation/offshore-company-formation/banner-img.png'
import BreadCrumbs from "../../../components/BreadCrumbs/BreadCrumbs";
import HeroRightImage from "../../../components/Constant/HeroRightImage/HeroRightImage";
import BannerPageImg from "../../../components/Constant/Banner Page Img/BannerPageImg";
import PageList from "../../../components/Constant/List/List";
import { TiTick } from "react-icons/ti";
import { GoDotFill } from "react-icons/go";
import Button from "../../../components/Constant/button/Button";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import CTA from "../../../components/Constant/cta/CTA";

const BreadCrumbsData = [
    {name: 'Offshore Advisory', link: '/'},
    {
        name: 'Offshore Company Formation',
        link: '/offshore-company-formation',
    },
]

function WesternSaharaIBC() {
    return (
        <main className='main'>
            <section className='section'>
                <BreadCrumbs data={BreadCrumbsData}/>

                <div className='container'>
                    <h1 className='section-title'>Western Sahara IBC (International Business Company)</h1>
                    <br/>
                    <div className='grid-container'>
                        <div className='flex-start'>
                            <h3 className='page-subtitle'>Fast Offshore Incorporation in Western Sahara</h3>
                            <p className='page-paragraph'>
                                A <b>Western Sahara IBC (International Business Company)</b> is one of the most cost-effective offshore company structures available. It offers <b>fast registration, simple maintenance, and full privacy,</b> making it suitable for holding, international trade, digital services, and as a vehicle for licensing.
                            </p>
                            <p className='page-paragraph'>
                                While recognition is not as high as Tier-1 jurisdictions, Western Sahara IBCs are often used by businesses seeking speed, <b>flexibility, and minimal costs.</b>
                            </p>

                            <PageList
                                items={[
                                    {
                                        title: "Low Cost",
                                        icon: TiTick,
                                    },
                                    {
                                        title: "Fast Incorporation",
                                        icon: TiTick,
                                    },
                                    {
                                        title: "Privacy",
                                        icon: TiTick,
                                    },
                                    {
                                        title: "Offshore Flexibility",
                                        icon: TiTick,
                                    },
                                ]}
                            />


                            <Button
                                text="Request a Western Sahara IBC Proposal →"
                                link="/consultation"
                                type="primary"
                                size="large"
                            />

                        </div>

                        <HeroRightImage src={HeroImg}/>
                    </div>
                    <BannerPageImg src={BannerImg}/>
                    <br/><br/>

                    <div className='flex-start'>
                        <h3 className='page-title'>
                            Why Choose a Western Sahara IBC?
                        </h3>
                        <PageList
                            items={[
                                {
                                    title: "Fast & Affordable",
                                    paragraph:
                                        "Incorporation completed in days, lower fees vs Malta, Cyprus, or Isle of Man.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Flexible Structure",
                                    paragraph: "No restrictions on business activities (except locally).",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Privacy",
                                    paragraph: "Shareholder & director details kept confidential.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Low Maintenance",
                                    paragraph: "Minimal filing & annual requirements.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Ideal for Startups",
                                    paragraph: "Perfect for entrepreneurs, SPVs, and digital businesses.",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>
                            Key Features of a Western Sahara IBC
                        </h3>
                        <PageList
                            items={[
                                {
                                    title: "100% foreign ownership allowed",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "No minimum paid-up capital requirement",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "At least 1 shareholder and 1 director",
                                    paragraph: "(individual or corporate)",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Local registered office & agent required",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Confidentiality protected under company law",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "No restrictions on issuing shares in different classes",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Can be combined with licenses",
                                    paragraph: "(gaming, crypto, brokerage, banking)",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>
                            Benefits of Western Sahara IBC
                        </h3>
                        <PageList
                            items={[
                                {
                                    title: "Tax-Friendly",
                                    paragraph: "No local corporate tax on offshore-sourced income.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "No Exchange Controls",
                                    paragraph: "Free movement of capital internationally.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Asset Protection",
                                    paragraph: "IBCs shield owners from liability.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Versatile Use",
                                    paragraph:
                                        "Holding company, IP management, online business, or license vehicle.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Simple Compliance",
                                    paragraph: "No annual reporting of accounts (unless licensed).",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Incorporation Requirements</h3>
                        <PageList
                            items={[
                                {
                                    title: "1 shareholder & 1 director",
                                    paragraph: "(can be the same person)",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "No residency requirements",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Company secretary not required",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Local registered agent + address in Western Sahara",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "KYC documents",
                                    paragraph: "(passport, proof of address, CV)",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Incorporation Process</h3>
                        <PageList
                            items={[
                                {
                                    title: "Consultation & Structuring",
                                    paragraph: "Decide ownership & shareholding.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Name Check & Reservation",
                                    paragraph: "Ensure company name availability.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Document Preparation",
                                    paragraph: "Memorandum & Articles of Association.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Filing with CRA",
                                    paragraph: "Submission to the Corporate Registrar Authority.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Certificate of Incorporation",
                                    paragraph: "Company officially registered.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Optional Add-Ons",
                                    paragraph: "Nominee services, apostilles, banking arrangements.",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Timeline & Costs</h3>
                        <PageList
                            items={[
                                {
                                    title: "Timeline",
                                    paragraph: "3–7 business days",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Setup Cost",
                                    paragraph: "From USD 1,500+ (including government fees & registered agent)",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Annual Renewal",
                                    paragraph:
                                        "Registered agent, government license, nominee services if used",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Common Uses of Western Sahara IBC</h3>
                        <PageList
                            items={[
                                {
                                    title: "Holding company",
                                    paragraph: "For shares & assets",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Trading & e-commerce vehicle",
                                    paragraph: "For international markets",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Licensing structure",
                                    paragraph: "For gaming, forex, crypto, or banking licenses",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Intellectual property (IP) holding",
                                    paragraph: "For royalty routing",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Wealth planning & asset protection",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Why Offshore Advisory?</h3>
                        <PageList
                            items={[
                                {
                                    title: "Licensed Corporate Services Provider in Western Sahara",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Fast-track incorporation with CRA recognition",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Add-on services",
                                    paragraph: "Nominee directors, compliance, apostilles",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Integration with licenses & banking solutions worldwide",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Comparative insights",
                                    paragraph: "Western Sahara vs Mwali vs Anjouan vs Seychelles",
                                    icon: GoDotFill,
                                },
                            ]}
                        />


                    </div>

                    <FAQList title='Frequently Asked Questions (FAQ)' data={faqData} />

                    <Testimonials title='Client Testimonials' testimonials={testimonialsData}/>

                    <CTA
                        title="Looking for fast offshore incorporation?"
                        description="A Western Sahara IBC offers speed, privacy, and flexibility — ideal for holding, trading, or licensing."
                        buttonText="Book a Western Sahara IBC Consultation →"
                        buttonLink="/consultation"
                    />

                </div>

            </section>
        </main>
    )
}

export default WesternSaharaIBC

const faqData = [
    {
        question: "How long does it take to register a Western Sahara IBC?",
        content: [
            {
                type: "answer",
                text: "Typically 3–7 business days."
            },
        ],
    },
    {
        question: "Is there a minimum capital requirement?",
        content: [
            {
                type: "answer",
                text: "No — an IBC can be incorporated without paid-up capital."
            },
        ],
    },
    {
        question: "Can foreigners own 100%?",
        content: [
            {
                type: "answer",
                text: "Yes, there are no restrictions on foreign shareholders."
            },
        ],
    },
    {
        question: "Do I need to file annual accounts?",
        content: [
            {
                type: "answer",
                text: "No, unless the company holds a regulated license (e.g., gaming, banking)."
            },
        ],
    },
    {
        question: "Can I open a bank account with a Western Sahara IBC?",
        content: [
            {
                type: "answer",
                text: "Yes, though accounts are usually opened outside Western Sahara (UAE, Mauritius, Seychelles, or Europe)."
            },
        ],
    },
];


const testimonialsData = [
    {
        quote:
            "We set up a Western Sahara IBC to hold our forex license. Offshore Advisory handled the full incorporation process.”",
        author: "David P.",
        role: "Brokerage CEO",
    },
    {
        quote:
            "Our iGaming startup launched quickly thanks to a Western Sahara IBC. Offshore Advisory made it simple and cost-effective.",
        author: "Maria K.",
        role: "Gaming Entrepreneur",
    },
];